import cloneDeep from 'lodash/cloneDeep';
import intersection from 'lodash/intersection';
import { HYDRATE } from 'next-redux-wrapper';

import {
    APPLY_CHANNELS_FILTERS,
    CHANNELS_PACKAGE_ID,
    CLEAR_CHANNELS_PACKAGE_ID,
    CLEAR_SEARCH_CHANNELS_FILTER,
    CLEAR_THEME_CHANNELS_FILTER,
    GET_ALL_CHANNELS,
    GET_BUNDLES_BANNER,
    GET_BUNDLES_TARIFFS,
    GET_BUNDLES_TARIFFS_SELF_ORDER,
    GET_CHANNEL_THEMES,
    GET_TARIFF_LINES,
    SET_FILTER_FOR_CHANNELS,
    SET_FILTERED_TARIFFS_ID,
    SET_SEARCH_CHANNELS_FILTER,
    SET_SELECTED_TARIFF_ID,
    SET_TARIFF_CHANNELS,
    SET_THEME_CHANNELS_FILTER,
} from '../actionTypes/bundles';

export const initialState = {
    banner: null,
    themeId: 0,
    tariffs: {
        byId: {},
        allIds: [],
    },
    tariffsSelfOrder: {
        byId: {},
        allIds: [],
    },
    tariffLines: [],
    tariffLine: {},
    allChannels: [],
    channelsByBids: {},
    channelThemes: [],
    tariffChannels: [],
    channelsFilters: {},
    channelsFiltersIsApply: false,
    filteredChannels: [],
    selectedTariffId: '',
    selectedFilter: { value: 0, label: 'Все каналы' },
    filteredTariffsId: [],
    tariffBuilder: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case HYDRATE:
            return { ...state, ...action.payload.bundles };

        case GET_BUNDLES_BANNER: {
            return {
                ...state,
                banner: action.payload,
            };
        }

        case GET_BUNDLES_TARIFFS: {
            return {
                ...state,
                tariffs: normalizeBundlesList(action.payload),
            };
        }

        case GET_BUNDLES_TARIFFS_SELF_ORDER: {
            return {
                ...state,
                tariffsSelfOrder: normalizeBundlesList(action.payload),
            };
        }

        case GET_TARIFF_LINES: {
            return {
                ...state,
                tariffLines: action.payload,
            };
        }

        case GET_ALL_CHANNELS: {
            return {
                ...state,
                allChannels: action.payload,
            };
        }

        case SET_SEARCH_CHANNELS_FILTER: {
            return {
                ...state,
                channelsFilters: {
                    ...state.channelsFilters,
                    search: action.payload,
                },
            };
        }

        case CLEAR_SEARCH_CHANNELS_FILTER: {
            const filters = cloneDeep(state.channelsFilters);
            delete filters.search;

            return {
                ...state,
                channelsFilters: filters,
            };
        }

        case SET_THEME_CHANNELS_FILTER: {
            return {
                ...state,
                channelsFilters: {
                    ...state.channelsFilters,
                    theme: action.payload,
                },
            };
        }

        case CLEAR_THEME_CHANNELS_FILTER: {
            const filters = cloneDeep(state.channelsFilters);
            delete filters.theme;
            return {
                ...state,
                channelsFilters: filters,
            };
        }

        case APPLY_CHANNELS_FILTERS: {
            const filters = state.channelsFilters;

            const channels = state.tariffChannels;
            const isHaveFilters = Object.keys(filters).length > 0;

            if (!isHaveFilters || !channels) {
                return {
                    ...state,
                    channelsFiltersIsApply: false,
                };
            }

            let filteredChannels = cloneDeep(channels);

            const isSearch = !!state.channelsFilters?.search && state.channelsFilters.search !== '';

            if (isSearch) {
                for (const key in filters) {
                    if (key === 'search') {
                        const searchValue = filters[key];

                        filteredChannels = filteredChannels.filter(channel => channel.title.toLowerCase().includes(searchValue));
                    }
                }
            } else {
                for (const key in filters) {
                    if (key === 'theme') {
                        const themeId = (filters[key]).toString();
                        filteredChannels = filteredChannels.filter(({ categoryId = '' }) => (categoryId).toString() === themeId);
                    }
                }
            }

            return {
                ...state,
                channelsFiltersIsApply: true,
                filteredChannels,
            };
        }

        case GET_CHANNEL_THEMES: {
            return {
                ...state,
                channelThemes: action.payload,
            };
        }

        case SET_TARIFF_CHANNELS: {
            // TODO: Доработать в рамках https://ticket.ertelecom.ru/browse/WEB-41392
            const { packages, isOfferChannels } = action.payload;
            const channels = state.allChannels;

            const tariffChannels = isOfferChannels
                ? channels.filter(channel => !!packages.includes(channel.channelId))
                : channels.filter(channel => !!intersection(packages, channel.bids).length);

            return {
                ...state,
                tariffChannels: tariffChannels,
            };
        }

        case CHANNELS_PACKAGE_ID: {
            return { ...state, themeId: action.payload };
        }

        case CLEAR_CHANNELS_PACKAGE_ID: {
            const idToShowAllChannels = 0;
            return { ...state, themeId: idToShowAllChannels };
        }

        case SET_SELECTED_TARIFF_ID:
            return ({
                ...state,
                selectedTariffId: action.payload,
            });

        case SET_FILTER_FOR_CHANNELS:
            return ({
                ...state,
                selectedFilter: action.payload,
            });

        case SET_FILTERED_TARIFFS_ID: {
            return { ...state, filteredTariffsId: [...action.payload] };
        }

        default: {
            return state;
        }
    }
};

function normalizeBundlesList(tariffs) {
    const ids = Object.keys(tariffs);
    return {
        byId: tariffs,
        allIds: [...ids],
    };
}
